<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">    
    <a target="_self" [href]="evcrLink" style="margin-right: 10px;" *ngIf="showHomeButton">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px;  color:white;"></mat-icon>
    </a>
    <span class="text-color-white">{{ 'ml_144008' | translate }}</span>
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>    
    <span class="example-spacer"></span>
    <a routerLink="/team-message" style="margin-top: 10px;">
        <mat-icon [matBadge]="teamMessageNotReadCunt" matBadgeColor="warn" style="color:white">mail_outline</mat-icon>
    </a>
    
</mat-toolbar>

<div class="warning" *ngIf="!apexId">
    <p>Please Login</p>        
</div>

<mat-nav-list *ngIf="!apexId">    
    <a mat-list-item (click)="login()" class="text-color-blue">            
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>            
            <span class="text-color-blue" style="font-size: 20px;">Login</span>
        </div>
    </a>
</mat-nav-list>

<mat-nav-list *ngIf="apexId">
    
    <a mat-list-item class="text-color-blue">        
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_144112' | translate }}</span>            
        </div>
    </a>

    <div class="warning" *ngIf="!isLoading">        
        <app-team-message-data></app-team-message-data>
    </div>
    
    <mat-divider></mat-divider>

    <a mat-list-item (click)="onGoToMonthPerformance()" class="text-color-blue">
        
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_143973' | translate }}</span>
        </div>
    </a>
    
    <mat-divider></mat-divider>
    
    
    
    
    <a mat-list-item (click)="onGoToScore()" class="text-color-blue">
        <!-- My Score Card -->
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_143975' | translate }}</span>
        </div>
    </a>
    <mat-divider></mat-divider>
    
    <a mat-list-item (click)="onGoToEconomy()" class="text-color-blue" *ngIf="showEconomyKpi">
        <!-- Economy KPI -->
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_144004' | translate }}</span>
        </div>
    </a>
    <mat-divider></mat-divider>
    
    <a mat-list-item (click)="onGoToAchievement()" class="text-color-blue">
        <!-- My Achievement -->
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_143977' | translate }}</span>
        </div>
    </a>
    <mat-divider></mat-divider>
    
    <a mat-list-item (click)="onGoToCoaching()" class="text-color-blue">
        <!-- My Coaching -->
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_143978' | translate }}</span>
        </div>
    </a>

    <a mat-list-item (click)="onGoToLearnex()" class="text-color-blue">
        
        <div>
            <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle" class="text-color-green" style="vertical-align: middle;  margin-right:10px;" ></mat-icon>
            
            <span class="text-color-blue" style="font-size: 20px;">{{ 'ml_151240' | translate }}</span>
        </div>
    </a>
    

</mat-nav-list>

<p style="position: fixed; left: 0; bottom: 0px; margin-bottom: 0px; z-index: -20; color: lightgrey;">v.20240801.1438</p>